<script setup>
import fiveMixin from '@/composables/fiveMixin';

const { ...five } = fiveMixin();

const birthEl = ref(null);
const itemRefs = ref([]);
const borderStyle = ref({});
const border2Style = ref({});

const props = defineProps({
  prBirthData: {
    type: Object,
    default: null,
  },
  prBirthJijanggan: {
    type: Object,
    default: () => ({}),
  },
  prLangMode: {
    type: String,
    default: '',
  },
  prBirthTitle: {
    type: String,
    default: '',
  },
  prType: {
    type: String,
    default: '',
  },
  prCurDaeun: {
    type: Object,
    default: () => ({}),
  },
  prTransdata: {
    type: Object,
    default: () => ({}),
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  selectedData: {
    type: Object,
    default: () => ({}),
  },
  activePage: {
    type: String,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
});

function getYearSix(data, pos) {
  let txt = '';
  const posEng = getPosEng(pos);
  txt = data?.[posEng]?.six;
  return txt;
}
function getPosEng(pos) {
  let txt = '';
  if (pos === '년') txt = 'year';
  if (pos === '월') txt = 'month';
  if (pos === '일') txt = 'day';
  if (pos === '시') txt = 'hour';
  return txt;
}
function getValueTxt(data, pos, val) {
  let txt = '';
  const posEng = getPosEng(pos);
  txt = data?.[posEng]?.[val];
  if (val === 'sal') {
    txt = txt ? txt[0] : '';
  }
  return txt;
}

// 오행도 클릭에 따른 스타일 적용
const getGlobalIdx = (type, title, prBirthTitle) => {
  const posEng = getPosEng(title);
  const idxMap = {
    sky: { year: 0, month: 1, day: 2, hour: 3 },
    earth: { year: 4, month: 5, day: 6, hour: 7 },
  };
  const titleIndex = prBirthTitle.indexOf(title);
  if (titleIndex === -1) return null;
  return idxMap[type][posEng];
};

const getClass = (type, title, prBirthTitle) => {
  if (!props.isActive || props.selectedData === null) return '';
  const currentIdx = getGlobalIdx(type, title, prBirthTitle);
  const classes = [];
  if (currentIdx === props.selectedData) {
    if (currentIdx === 2) {
      classes.push('ilgan');
    }
  } else {
    classes.push('inactive-wongook');
  }
  return classes.join(' ');
};

const isVisible = (...pages) => pages.includes(props.activePage);

/** activePage에 따라 border 위치/크기 동적 계산 */
const calcBorder = () => {
  if (!birthEl.value || !itemRefs.value.length) return;
  const parentRect = birthEl.value.getBoundingClientRect();

  if (props.activePage === 'page1') {
    // '일' 컬럼 (시일월년 → index 1)
    const dayIdx = props.prBirthTitle.indexOf('일');
    const dayCol = itemRefs.value[dayIdx];
    if (!dayCol) return;
    const colRect = dayCol.getBoundingClientRect();
    // 2번째 li(십성) ~ 3번째 li(천간) 감싸기
    const sixLi = dayCol.querySelectorAll('li')[1]; // 십성
    const skyLi = dayCol.querySelectorAll('li')[2]; // 천간
    if (!sixLi || !skyLi) return;
    const topRect = sixLi.getBoundingClientRect();
    const botRect = skyLi.getBoundingClientRect();
    borderStyle.value = {
      left: `${colRect.left - parentRect.left + 4}px`,
      top: `${topRect.top - parentRect.top - 4}px`,
      width: `64px`,
      height: `${botRect.bottom - topRect.top + 8}px`,
      borderRadius: `12px`,
    };
    border2Style.value = {};
  } else if (props.activePage === 'page2') {
    // 전체 items-wrap의 2번째 li(십성 sky) 행
    const firstCol = itemRefs.value[0];
    const lastCol = itemRefs.value[itemRefs.value.length - 1];
    if (!firstCol || !lastCol) return;
    const sixLi = firstCol.querySelectorAll('li')[1];
    const lastSixLi = lastCol.querySelectorAll('li')[1];
    if (!sixLi || !lastSixLi) return;
    const topRect = sixLi.getBoundingClientRect();
    const rightRect = lastSixLi.getBoundingClientRect();
    borderStyle.value = {
      left: `${topRect.left - parentRect.left}px`,
      top: `${topRect.top - parentRect.top - 2}px`,
      width: `${rightRect.right - topRect.left}px`,
      height: `24px`,
      borderRadius: `8px`,
    };
    // border2: 5번째 li(십성 earth) 행
    const earthSixLi = firstCol.querySelectorAll('li')[4];
    const lastEarthSixLi = lastCol.querySelectorAll('li')[4];
    if (!earthSixLi || !lastEarthSixLi) return;
    const eTopRect = earthSixLi.getBoundingClientRect();
    const eRightRect = lastEarthSixLi.getBoundingClientRect();
    border2Style.value = {
      left: `${eTopRect.left - parentRect.left}px`,
      top: `${eTopRect.top - parentRect.top - 2}px`,
      width: `${eRightRect.right - eTopRect.left}px`,
      height: `24px`,
      borderRadius: `8px`,
    };
  } else if (props.activePage === 'page3') {
    // 6번째 li(십이운성) 행
    const firstCol = itemRefs.value[0];
    const lastCol = itemRefs.value[itemRefs.value.length - 1];
    if (!firstCol || !lastCol) return;
    const twelveLi = firstCol.querySelectorAll('li')[5];
    const lastTwelveLi = lastCol.querySelectorAll('li')[5];
    if (!twelveLi || !lastTwelveLi) return;
    const topRect = twelveLi.getBoundingClientRect();
    const rightRect = lastTwelveLi.getBoundingClientRect();
    borderStyle.value = {
      left: `${topRect.left - parentRect.left}px`,
      top: `${topRect.top - parentRect.top - 4}px`,
      width: `${rightRect.right - topRect.left}px`,
      height: `${topRect.height + 8}px`,
      borderRadius: `8px`,
    };
    border2Style.value = {};
  } else {
    borderStyle.value = {};
    border2Style.value = {};
  }
};

watch(
  () => props.activePage,
  () => nextTick(calcBorder),
);
onMounted(() => nextTick(calcBorder));
</script>

<template>
  <div class="ssb-wrapper" :class="{ 'ssb-mobile': isMobile }">
    <div ref="birthEl" class="ssb-birth" :class="{ 'ssb-mobile': isMobile }">
      <div class="ssb-tit-box">
        <li
          class="ssb-row ssb-row01"
          :class="isVisible('page1', 'page2') ? 'active-opacity' : 'inactive-opacity'"
        >
          <span>십성</span>
        </li>
        <li
          class="ssb-row ssb-row02"
          :class="isVisible('page1') ? 'active-opacity' : 'inactive-opacity'"
        >
          <span>천간</span>
        </li>
        <li
          class="ssb-row ssb-row03"
          :class="isVisible('page1') ? 'active-opacity' : 'inactive-opacity'"
        >
          <span>지지</span>
        </li>
        <li
          class="ssb-row ssb-row04"
          :class="isVisible('page1', 'page2') ? 'active-opacity' : 'inactive-opacity'"
        >
          <span>십성</span>
        </li>
        <li
          class="ssb-row ssb-row05"
          :class="isVisible('page1', 'page3') ? 'active-opacity' : 'inactive-opacity'"
        >
          <span>십이운성</span>
        </li>
        <li
          class="ssb-row ssb-row06"
          :class="isVisible('page1') ? 'active-opacity' : 'inactive-opacity'"
        >
          <span>십이신살</span>
        </li>
      </div>
      <div class="ssb-items-wrap">
        <ul
          v-for="(char, index) in prBirthTitle"
          :key="index"
          :ref="
            (el) => {
              if (el) itemRefs[index] = el;
            }
          "
          class="ssb-item-box txt-big"
        >
          <li>
            <span class="ssb-txt1">
              {{ char }}
            </span>
          </li>
          <li>
            <span
              class="ssb-txts"
              :class="[
                (activePage === 'page1' && char === '일') || activePage === 'page2'
                  ? 'active-opacity'
                  : 'inactive-opacity',
              ]"
            >
              {{ getYearSix(prBirthData?.sky, char) }} {{ char === '일' ? '(나)' : '' }}
            </span>
          </li>
          <li>
            <span
              class="txt-round xl"
              :class="[
                five.getColorFive(getValueTxt(prBirthData?.sky, char, 'value')),
                getClass('sky', char, prBirthTitle),
                prLangMode === 'CHNKOR' ? 'chnkor' : '',
                isVisible('page1') ? 'active-opacity' : 'inactive-opacity',
              ]"
            >
              <em v-if="prLangMode === 'CHNKOR'" class="chn">
                {{ five.getHanjaTxt(getValueTxt(prBirthData?.sky, char, 'value'), 'sky') }}
              </em>
              <em v-if="getValueTxt(prBirthData?.sky, char, 'value') === '-'" class="time-none">{{
                getValueTxt(prBirthData?.sky, char, 'value')
              }}</em>
              <em v-else class="txt-main">{{ getValueTxt(prBirthData?.sky, char, 'value') }}</em>
            </span>
          </li>
          <li>
            <span
              class="txt-round xl mb6 inactive-opacity"
              :class="[
                five.getColorFive(getValueTxt(prBirthData?.earth, char, 'value')),
                getClass('earth', char, prBirthTitle),
                prLangMode === 'CHNKOR' ? 'chnkor' : '',
                prLangMode,
              ]"
            >
              <em v-if="prLangMode === 'CHNKOR'" class="chn">
                {{ five.getHanjaTxt(getValueTxt(prBirthData?.earth, char, 'value'), 'earth') }}
              </em>
              <em v-if="getValueTxt(prBirthData?.sky, char, 'value') === '-'" class="time-none">{{
                getValueTxt(prBirthData?.sky, char, 'value')
              }}</em>
              <em v-else class="txt-main">{{ getValueTxt(prBirthData?.earth, char, 'value') }}</em>
            </span>
          </li>
          <li>
            <span
              class="ssb-txts"
              :class="isVisible('page2') ? 'active-opacity' : 'inactive-opacity'"
            >
              {{ getYearSix(prBirthData?.earth, char) }}
            </span>
          </li>
          <li>
            <span
              class="ssb-txts ssb-txt-earth-02"
              :class="isVisible('page3') ? 'active-opacity' : 'inactive-opacity'"
            >
              {{ getValueTxt(prBirthData?.earth, char, 'twelve') }}
            </span>
          </li>
          <li>
            <span class="ssb-txts ssb-txt-earth-02 inactive-opacity">{{
              getValueTxt(prBirthData?.earth, char, 'sal')
            }}</span>
          </li>
        </ul>
      </div>
      <!-- 테두리 (동적 계산) -->
      <div v-if="borderStyle.width" class="ssb-active-border" :style="borderStyle"></div>
      <div v-if="border2Style.width" class="ssb-active-border" :style="border2Style"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* ============================
   SummarySajuBirth - 독자적 스타일
   ============================ */

/* 오행 색상 */
$ssb-five01: #c23535; // 화
$ssb-five02: #404040; // 수
$ssb-five03: #5e9f1c; // 목
$ssb-five04: #949494; // 금
$ssb-five05: #db9823; // 토
$ssb-five06: #ebebeb; // -

/* 공통 변수 */
$ssb-gray200: #f8f8f8;
$ssb-gray600: #757575;
$ssb-gray700: #575757;
$ssb-gray800: #333333;

/* 오행 클래스 - fiveMixin의 getColorFive가 반환하는 클래스 */
:deep(.five01) {
  background-color: $ssb-five01;
  border-color: $ssb-five01;
  color: #fff;
  border: none;
}
:deep(.five02) {
  background-color: $ssb-five02;
  border-color: $ssb-five02;
  color: #fff;
  border: none;
}
:deep(.five03) {
  background-color: $ssb-five03;
  border-color: $ssb-five03;
  color: #fff;
  border: none;
}
:deep(.five04) {
  background-color: $ssb-five04;
  border-color: $ssb-five04;
  color: #fff;
  border: none;
}
:deep(.five05) {
  background-color: $ssb-five05;
  border-color: $ssb-five05;
  color: #fff;
  border: none;
}
:deep(.five06) {
  background-color: $ssb-five06 !important;
  border-color: transparent;
  color: $ssb-gray700 !important;
  border: none;
}

/* opacity 제어 */
.inactive-opacity {
  opacity: 0.5;
}
.active-opacity {
  opacity: 1;
  font-weight: 700 !important;
}

/* 래퍼 */
.ssb-wrapper {
  width: 360px;
  display: inline-block;
  transform-origin: top left;
  &.ssb-mobile {
    width: 360px;
  }
}

/* 메인 그리드 */
.ssb-birth {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
  padding: 12px 0;
  overflow-x: hidden;
  background: #fff;
  border-radius: 0;
  margin: 0;
  margin-top: 8px;
  border: none;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  position: relative;

  &.ssb-mobile {
    width: 360px;
    min-width: 360px;
  }
}

/* 아이템 감싸기 */
.ssb-items-wrap {
  display: flex;
  flex-direction: row;
  flex: 1 1 0;
  min-width: 0;
  gap: 0;
}

/* 왼쪽 타이틀 박스 */
.ssb-tit-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  width: 56px;
  min-width: 56px;
  padding-top: 25px;
  gap: 5px;

  li {
    height: 20px;
    min-height: 20px;
  }

  .ssb-row {
    width: 100%;
    line-height: 1;
    list-style: none;
    /* 천간/지지 행 */
    &:nth-child(2),
    &:nth-child(3) {
      height: auto;
    }

    span {
      background: $ssb-gray200;
      border-radius: 4px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      height: 20px;
      box-sizing: border-box;
      font-weight: 500;
      color: $ssb-gray600;
      width: 100%;
    }
  }
  .ssb-row01 span {
    height: 20px;
  }
  .ssb-row02 {
    margin-bottom: 2px;
  }
  .ssb-row02 span,
  .ssb-row03 span {
    height: 54px;
    display: flex;
  }
}

/* 아이템 박스 (년/월/일/시 각 컬럼) */
.ssb-item-box {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  max-width: none;
  border-right: none;
  padding: 0;
  padding-inline-start: 0;
  margin: 0;
  align-items: center;
  box-sizing: border-box;
  gap: 5px;
  list-style: none;

  li {
    width: 100%;
    height: 20px;
    min-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: none;
    padding: 0;
    box-sizing: border-box;
    line-height: 1;

    &:first-child {
      background: transparent;
    }

    /* 십성 행 */
    &:nth-child(2) {
    }

    /* 천간/지지 행 */
    &:nth-child(3) {
      margin-bottom: 2px;
    }

    &:nth-child(3),
    &:nth-child(4) {
      height: auto;
    }

    span {
      margin-bottom: 0;
    }
  }

  /* 하단 텍스트 (십성, 12운성, 신살) */
  li:nth-child(n + 5) {
    height: 20px;

    .ssb-txts {
      font-size: 14px;
      color: $ssb-gray800;
    }
  }
}

/* 타이틀 텍스트 (년/월/일/시) */
.ssb-txt1 {
  font-size: 14px;
  color: $ssb-gray600;
  font-weight: 400;
  white-space: nowrap;
}

/* 십성 등 텍스트 */
.ssb-txts {
  font-size: 14px;
  color: $ssb-gray800;
  font-weight: 400;
  display: inline-block;
  white-space: nowrap;
  text-align: center;
}

/* 활성 테두리 (위치는 JS에서 동적 계산) */
.ssb-active-border {
  position: absolute;
  border: 1px solid var(--Orange-200, #f80);
  background: rgba(255, 136, 0, 0.03);
  box-shadow: 0px 0px 10px 0px rgba(255, 136, 0, 0.3);
  pointer-events: none;
}

/* 오행도 클릭 스타일 */
.ssb-ilgan {
  /* 일간 선택 시 특별 스타일 - 필요에 따라 추가 */
}
.ssb-inactive-wongook {
  /* 비활성 원국 - 필요에 따라 추가 */
}
</style>
